import { frontendURL } from '../../../helper/URLHelper';
import BookmarksIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/bookmarks'),
    component: BookmarksIndex,
    name: 'bookmarks_index',
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
